export var TransactionSort;
(function (TransactionSort) {
    TransactionSort["DateDesc"] = "DATE_DESC";
    TransactionSort["DateAsc"] = "DATE_ASC";
    TransactionSort["AmountDesc"] = "AMOUNT_DESC";
    TransactionSort["AmountAsc"] = "AMOUNT_ASC";
})(TransactionSort || (TransactionSort = {}));
//# sourceMappingURL=transaction-sort.enum.js.map